import React from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import zIndex from '@mui/material/styles/zIndex';

const CustomSwitch = ({
  text,
  checked = true,
  handleCheckboxChange,
  name,
  disabled = false,
  textClassName = "",
}) => {
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 31.5,
    height: 19.5,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 1.5,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#356DAD",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16.5,
      height: 16.5,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <>
    <IOSSwitch sx={{ m: 1, zIndex: 2 }} checked={checked} onChange={handleCheckboxChange} name={name} disabled={disabled}/>
    <p className={textClassName} style={{ fontSize: "var(--font_size12)", fontWeight: "600" }}>{text}</p>
    </>
  );
};

export default CustomSwitch;
